const env = typeof import.meta !== 'undefined' && typeof import.meta.env !== 'undefined'
  ? import.meta.env
  : ({} as ImportMetaEnv);

export const DOCUMENTS_HUB_ENABLED = env.VITE_DOCUMENTS_HUB_ENABLED === 'true';
export const HR_HUB_ENABLED = env.VITE_HR_HUB_ENABLED === 'true';

export type HubFeatureFlags = {
  documenti: boolean;
  hr: boolean;
};

export function isHubEnabled(
  hubId: string,
  flags: HubFeatureFlags = { documenti: DOCUMENTS_HUB_ENABLED, hr: HR_HUB_ENABLED },
): boolean {
  if (hubId === 'documenti') return flags.documenti;
  if (hubId === 'hr') return flags.hr;
  return true;
}
